// ============================================================================
// cadastroSensivel — campos SENSÍVEIS do cadastro de profissionais (cliente)
// ============================================================================
// 06/10/2026 — decisão do dono: "pode fechar. Gerente cadastra salário em
// CADASTROS (tela Profissionais), não em Financeiro."
//
// Quem decide é o SERVIDOR (api/_lib/cadastro-sensivel.js): o /api/data devolve
// o fk_professionals PROJETADO pelo escopo da sessão, com a marca `_sensivel`
// por item:
//   - sem marca  → a sessão vê e edita os campos sensíveis daquele registro;
//   - 'leitura'  → vê, não edita (o próprio cadastro de quem não é operador);
//   - 'oculto'   → os campos sensíveis NÃO vieram (aniversário só dia/mês).
// E na gravação o servidor IGNORA sensível de registro que a sessão não pode
// editar. Aqui só o espelho pra tela não mostrar/enviar o que não deve e pra
// cópia local antiga (COMPLETA) ser trocada pela projetada.
//
// A lista abaixo é a MESMA do servidor (tests/cadastro-sensivel.test.mjs
// confere) — mudou lá, muda aqui.
// ============================================================================

export const MARCA = '_sensivel';
export const MARCA_OCULTO = 'oculto';
export const MARCA_LEITURA = 'leitura';

export const CAMPOS_SENSIVEIS = Object.freeze([
  // remuneração / folha
  'salarioBase', 'vtValor', 'vrValor', 'vrDiaria', 'inssValor', 'vtDescontoPct',
  'ajudaCusto', 'managerVariable', 'observacaoFolha', 'inPayroll', 'dataDemissao', 'payrollSourceId',
  // documentos e contato pessoal
  'cpf', 'rg', 'pis', 'ctps',
  'phone', 'email', 'telefonePessoal', 'emailPessoal',
  'endereco', 'enderecoResidencial', 'cep',
  'banco', 'agencia', 'conta', 'contaBancaria', 'dadosBancarios',
  'pix', 'chavePix', 'tipoChavePix',
]);

export const sensivelOculto = (p) => p?.[MARCA] === MARCA_OCULTO;
export const sensivelSoLeitura = (p) => p?.[MARCA] === MARCA_LEITURA;
// Sem marca = o servidor liberou edição (ou a cópia ainda é antiga — o
// servidor ignora o que não pode de qualquer jeito).
export const sensivelSemMarca = (p) => !!p && !p[MARCA];

// Tira os campos sensíveis de um objeto (o formulário não manda nem 0 nem
// vazio pra campo que a sessão não pode editar).
export function semSensiveis(obj) {
  const out = { ...(obj || {}) };
  for (const f of CAMPOS_SENSIVEIS) delete out[f];
  return out;
}

// Depois do merge local×nuvem (storage.loadFromCloud): reaplica a projeção do
// servidor. Item que veio MARCADO da nuvem tem os sensíveis vindos SÓ da
// nuvem (a cópia local antiga — completa — não sobrevive nem quando o item
// local "vence" o merge por updatedAt). Item que veio SEM marca e estava
// marcado aqui (o aparelho era de outra conta) → vale o da nuvem inteiro.
// Item só local (criado aqui, ainda não subiu) fica como está.
export function reprojetarLocal(merged, nuvem) {
  if (!Array.isArray(merged) || !Array.isArray(nuvem)) return merged;
  const nuvemPorId = new Map(nuvem.filter(x => x && x.id).map(x => [x.id, x]));
  return merged.map(item => {
    if (!item || !item.id) return item;
    const c = nuvemPorId.get(item.id);
    if (!c) return item;
    const marca = c[MARCA];
    if (!marca) return item[MARCA] ? c : item;
    const out = { ...item, [MARCA]: marca };
    for (const f of CAMPOS_SENSIVEIS) {
      if (Object.prototype.hasOwnProperty.call(c, f)) out[f] = c[f];
      else delete out[f];
    }
    if (marca === MARCA_OCULTO) {
      if (Object.prototype.hasOwnProperty.call(c, 'birthday')) out.birthday = c.birthday;
      else delete out.birthday;
    }
    return out;
  });
}
